import React, { forwardRef } from "react";

const InputField = forwardRef(({ placeholder, value, onChange }, ref) => (
  <input
    type="text"
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    /*disabled={!setButtonEnabled}*/
    className="input-field"
    ref={ref}
  />
));

export default InputField;